import { z } from "zod";

export const commentSchema = z.object({
  id: z.string().or(z.number()),
  text: z.string(),
  createdAt: z.string().optional(),
  lastUpdatedAt: z.string().nullable().optional(),
  isEdited: z.boolean().optional(),
  isSystem: z.boolean().optional(),
  author: z
    .union([
      z.string(),
      z.object({
        displayName: z.string().nullable().optional(),
        email: z.string().nullable().optional(),
        isDeleted: z.boolean().optional(),
      }),
    ])
    .optional(),
});

export const updateCommentRequestSchema = z.object({
  text: z.string().min(1, "Text is required"),
});

export const createCommentRequestSchema = z.object({
  text: z.string().min(1, "Text is required"),
  fileId: z.string().min(0, "File ID is required"),
});
